import React, { useState } from 'react';
import NavBar from '../components/Navbar/NavBar';
import HeroSection from '../sections/HeroSection';
import AboutSection from '../sections/AboutSection';
import VolunteerSection from '../sections/VolunteerSection';
import EventsSection from '../sections/EventsSection';
import DonationsSection from '../sections/DonationsSection';
import SupportersSection from '../sections/SupportersSection';
import PageFooter from '../components/PageFooter';
import DonationModal from '../components/DonationModal';
import useScrollPosition from '../hooks/useScrollPosition';

const Home = () => {
  const scrollY = useScrollPosition();
  const [isDonationModalOpen, setIsDonationModalOpen] = useState(false);

  const openDonationModal = () => setIsDonationModalOpen(true);
  const closeDonationModal = () => setIsDonationModalOpen(false);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div className="hero">
      <NavBar />
      <HeroSection onDonateClick={openDonationModal} />
      <AboutSection />
      <div className="container mx-auto px-4 sm:px-6 pt-6 pb-6 sm:py-16 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 items-start">
          <VolunteerSection />
          <EventsSection />
        </div>
      </div>
      <DonationsSection onDonateClick={openDonationModal} />
      <SupportersSection />
      <PageFooter />

      {scrollY > 400 && (
        <button
          onClick={scrollToTop}
          aria-label="Back to top"
          className="fixed bottom-6 right-6 z-50 bg-green-600 hover:bg-green-700 text-white p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 min-w-[48px] min-h-[48px] flex items-center justify-center"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 10l7-7m0 0l7 7m-7-7v18" />
          </svg>
        </button>
      )}

      {isDonationModalOpen && (
        <DonationModal isOpen={isDonationModalOpen} onClose={closeDonationModal} />
      )}
    </div>
  );
};

export default Home;
